export default contestsHash => {

    if (!document.querySelector('body').classList.contains('contest-hashed')) {

        document.querySelector('body').classList.add('contest-hashed');

        const hash = window.location.hash.substr(1);

        if (hash !== '') {

            let headerSticky = document.querySelector('.main-header.sticky');
            let headerStickyHeight = typeof (headerSticky) != 'undefined' && headerSticky != null ? headerSticky.offsetHeight : 52 + 10;
            let section = document.getElementById(hash);
            let offset = section.getBoundingClientRect().top + window.scrollY - headerStickyHeight;
            document.documentElement.style.scrollBehavior = 'auto';
            window.scrollTo(0, offset);
            document.documentElement.style.scrollBehavior = 'smooth';
            if (section.querySelectorAll('.see-more').length > 0) {
                setTimeout(function () {
                    section.querySelector('.see-more').click();
                }, 50)
            }
            setTimeout(function () {
                offset = section.getBoundingClientRect().top + window.scrollY - headerStickyHeight;
                window.scrollTo(0, offset);
                //document.documentElement.scrollTop = document.body.scrollTop = offset;
            }, 50)
        }
    }

};
